import { stats } from "@/lib/site-data";
import { Reveal } from "@/components/Reveal";
import { useCountUp } from "@/hooks/use-count-up";

function StatItem({ value, suffix, label }: { value: number; suffix: string; label: string }) {
  const { ref, value: current } = useCountUp<HTMLDivElement>(value);
  return (
    <div ref={ref} className="text-center lg:text-left">
      <div className="flex items-baseline justify-center gap-1 lg:justify-start">
        <span className="text-5xl font-extrabold tracking-tight text-foreground sm:text-6xl">
          {current}
        </span>
        <span className="text-3xl font-extrabold text-primary-dark sm:text-4xl">{suffix}</span>
      </div>
      <p className="mt-2 text-xs font-bold uppercase tracking-[0.14em] text-primary-dark sm:text-sm">
        {label}
      </p>
    </div>
  );
}

export function Stats() {
  return (
    <section className="relative overflow-hidden bg-background py-20 md:py-28">
      {/* Angled green accent slash */}
      <div
        className="absolute left-1/2 top-10 hidden h-14 w-[60%] -translate-x-1/2 bg-primary/90 md:block"
        style={{ clipPath: "polygon(8% 0, 100% 0, 92% 100%, 0% 100%)" }}
        aria-hidden
      />

      <div className="container-artbaz relative">
        <Reveal className="content-artbaz grid items-center gap-12 lg:grid-cols-[minmax(0,0.8fr)_1.6fr] lg:gap-16">
          <div>
            <span className="eyebrow">Dôvera v číslach</span>
            <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              Čísla, ktoré hovoria za nás
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-6">
            {stats.map((stat) => (
              <StatItem key={stat.label} {...stat} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
